module.exports = __webpack_public_path__ + "img/Logo-PBP-Wit-hor.3d6eecff.png";